var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMissionProve(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 630,
    height: 529,
    viewBox: "0 0 630 529",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_2600)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_110_2600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.609 345.754C459.762 345.754 499.608 305.917 499.608 256.775C499.608 207.634 459.762 167.797 410.609 167.797C361.456 167.797 321.609 207.634 321.609 256.775C321.609 305.917 361.456 345.754 410.609 345.754Z",
    stroke: "#6A7C89",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_110_2600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.652 345.754C281.805 345.754 321.651 305.917 321.651 256.775C321.651 207.634 281.805 167.797 232.652 167.797C183.499 167.797 143.652 207.634 143.652 256.775C143.652 305.917 183.499 345.754 232.652 345.754Z",
    stroke: "#6A7C89",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M315.477 477.206C433.926 477.206 529.949 381.769 529.949 264.042C529.949 146.314 433.926 50.877 315.477 50.877C197.027 50.877 101.004 146.314 101.004 264.042C101.004 381.769 197.027 477.206 315.477 477.206Z",
    stroke: "#6A7C89",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "12.47 13.95 12.47 13.95 12.47 13.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.476 464.17C426.682 464.17 516.832 374.57 516.832 264.042C516.832 153.514 426.682 63.9141 315.476 63.9141C204.27 63.9141 114.12 153.514 114.12 264.042C114.12 374.57 204.27 464.17 315.476 464.17Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.552 436.888C483.621 397.337 529.241 287.871 489.448 192.388C449.655 96.9045 339.517 51.5619 243.448 91.1123C147.379 130.663 101.759 240.129 141.552 335.612C181.345 431.095 291.483 476.438 387.552 436.888Z",
    stroke: "#6A7C89",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "12.46 13.93 12.46 13.93 12.46 13.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.012 236.334C246.342 273.426 384.529 273.426 514.858 236.334",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.082 253.395C143.489 243.442 142.997 227.795 132.983 218.446C122.97 209.096 107.226 209.585 97.8196 219.538C88.4129 229.49 88.9049 245.138 98.9185 254.487C108.932 263.836 124.676 263.347 134.082 253.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.082 253.395C143.489 243.442 142.997 227.795 132.983 218.446C122.97 209.096 107.226 209.585 97.8196 219.538C88.4129 229.49 88.9049 245.138 98.9185 254.487C108.932 263.836 124.676 263.347 134.082 253.395Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.341 260.996C532.748 258.015 541.185 244.796 538.186 231.47C535.186 218.144 521.886 209.758 508.479 212.739C495.071 215.72 486.634 228.94 489.633 242.265C492.632 255.591 505.933 263.977 519.341 260.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.341 260.996C532.748 258.015 541.185 244.796 538.186 231.47C535.186 218.144 521.886 209.758 508.479 212.739C495.071 215.72 486.634 228.94 489.633 242.265C492.632 255.591 505.933 263.977 519.341 260.996Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.477 63.873L262.558 170.946H368.396L315.477 63.873Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.477 132.408L262.558 239.481H368.396L315.477 132.408Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.477 395.921L368.396 288.889H262.558L315.477 395.921Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.477 464.456L368.396 357.424H262.558L315.477 464.456Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.438 357.424H334.555L315.476 395.921L296.438 357.424Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.476 132.408L296.438 170.946L334.555 170.987L315.476 132.408Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.476 63.873V132.408",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.476 394V462.494",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.471 264.042C396.471 308.498 360.211 344.542 315.475 344.542C270.739 344.542 234.479 308.498 234.479 264.042C234.479 219.587 270.739 183.543 315.475 183.543C360.211 183.543 396.471 219.587 396.471 264.042Z",
    fill: "url(#paint0_linear_110_2600)",
    stroke: "#6A7C89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.964 394.618C388.417 394.618 447.151 336.148 447.151 264.022C447.151 191.896 388.417 133.426 315.964 133.426C243.511 133.426 184.776 191.896 184.776 264.022C184.776 336.148 243.511 394.618 315.964 394.618Z",
    stroke: "#6A7C89",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "12.6 14.16 12.6 14.16 12.6 14.16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.387 278.954H291.553H289.133V239.254H319.597C328.654 239.254 334.895 244.046 338.41 250.786C340.21 254.318 341.284 258.157 341.572 262.087C341.88 266.039 341.439 270.013 340.271 273.811C337.883 281.55 332.359 287.915 323.672 289.377C320.831 289.737 317.962 289.843 315.101 289.696C314.278 289.696 313.397 289.696 311.693 289.696V284.976C312.376 284.976 313.8 284.976 315.175 285.024C317.736 285.151 320.304 285.063 322.849 284.76C329.436 283.642 333.725 278.619 335.619 272.485C336.595 269.234 336.952 265.838 336.673 262.462C336.437 259.154 335.536 255.923 334.022 252.951C331.297 247.743 326.463 243.998 319.547 243.998H293.999V274.258H298.387V278.954Z",
    fill: "#0A1214"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.397 284.952L301.048 285.016V251.784H305.914V289.68L303.485 289.704L289.414 289.656L289.397 284.952Z",
    fill: "#0A1214"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.048 250.123H318.338C318.379 250.123 330.129 250.922 330.161 264.77C330.161 278.347 320.767 278.746 317.416 278.898H317.169C315.72 278.97 307.618 278.962 301.023 278.938V274.234C307.536 274.234 315.498 274.234 316.922 274.234H317.177C319.318 274.138 325.32 273.867 325.304 264.81C325.304 255.969 318.923 254.971 318.066 254.875H301.023L301.048 250.123Z",
    fill: "#0A1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.099 254.625C125.818 254.625 133.697 246.794 133.697 237.134C133.697 227.474 125.818 219.643 116.099 219.643C106.379 219.643 98.5 227.474 98.5 237.134C98.5 246.794 106.379 254.625 116.099 254.625Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.986 254.625C524.706 254.625 532.585 246.794 532.585 237.134C532.585 227.474 524.706 219.643 514.986 219.643C505.267 219.643 497.388 227.474 497.388 237.134C497.388 246.794 505.267 254.625 514.986 254.625Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.744 464.765C323.744 463.149 323.262 461.569 322.358 460.225C321.455 458.881 320.17 457.833 318.668 457.215C317.165 456.596 315.511 456.433 313.916 456.749C312.321 457.064 310.856 457.842 309.706 458.986C308.555 460.129 307.772 461.586 307.455 463.171C307.138 464.757 307.3 466.4 307.923 467.893C308.545 469.387 309.599 470.663 310.952 471.561C312.304 472.459 313.894 472.939 315.52 472.939C317.701 472.939 319.793 472.078 321.336 470.545C322.878 469.013 323.744 466.933 323.744 464.765Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.744 64.6739C323.744 63.0574 323.262 61.4764 322.358 60.1322C321.455 58.7881 320.17 57.7407 318.668 57.122C317.165 56.5034 315.511 56.3417 313.916 56.6571C312.321 56.9725 310.856 57.751 309.706 58.894C308.555 60.0371 307.772 61.4931 307.455 63.0786C307.138 64.6641 307.3 66.3084 307.923 67.8019C308.545 69.2954 309.599 70.5714 310.952 71.4696C312.304 72.3677 313.894 72.8474 315.52 72.8474C317.701 72.8474 319.793 71.9857 321.336 70.4529C322.878 68.92 323.744 66.8417 323.744 64.6739Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_110_2600",
    x: 317.359,
    y: 167.547,
    width: 186.499,
    height: 186.457,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_110_2600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_110_2600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_110_2600",
    x: 139.402,
    y: 167.547,
    width: 186.499,
    height: 186.457,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_110_2600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_110_2600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_110_2600",
    x1: 315.5,
    y1: 183.5,
    x2: 315.236,
    y2: 345.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.467477,
    stopColor: "#34DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6FFE5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_2600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 449,
    height: 428,
    fill: "white",
    transform: "translate(90.5 50.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionProve);
export default __webpack_public_path__ + "static/media/missionProve.d4a7027c0fe70ee54b89b18b3db43a70.svg";
export { ForwardRef as ReactComponent };